export const QA_NAME_CALENDAR_RAIL = 'calendarRail'
